var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.562256,
    y: 0.844955,
    width: 43.9378,
    height: 43.3101,
    rx: 6.27682,
    fill: "#F19E93"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1767 22.5011H15.9294M32.7706 21.9055C32.8822 21.9599 32.9763 22.0445 33.0421 22.1498C33.1078 22.2551 33.1427 22.3768 33.1426 22.5009C33.1425 22.6251 33.1075 22.7467 33.0415 22.8519C32.9756 22.9571 32.8814 23.0416 32.7697 23.0958L12.7828 32.721C12.6633 32.7785 12.5293 32.7988 12.3981 32.7792C12.2669 32.7596 12.1447 32.701 12.0472 32.6111C11.9497 32.5212 11.8815 32.404 11.8515 32.2749C11.8214 32.1457 11.8308 32.0105 11.8785 31.8867L15.3968 22.7381C15.4555 22.5855 15.4555 22.4167 15.3968 22.2641L11.8794 13.1146C11.8321 12.991 11.823 12.8561 11.8531 12.7272C11.8833 12.5984 11.9515 12.4815 12.0487 12.3918C12.146 12.302 12.2679 12.2435 12.3988 12.2238C12.5297 12.2041 12.6634 12.2241 12.7828 12.2812L32.7706 21.9055Z",
    stroke: "white",
    strokeWidth: 2.11523,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send-icon.a30e570a3a26e936d3b9c1e2c5657946.svg";
export { ForwardRef as ReactComponent };